var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-list",
    { staticClass: "q-mb-md" },
    [
      _c(
        "q-collapsible",
        {
          attrs: { icon: "fas fa-filter", label: _vm.getNameFilter },
          on: { click: _vm.toggle },
          model: {
            value: _vm.open,
            callback: function($$v) {
              _vm.open = $$v
            },
            expression: "open"
          }
        },
        [
          _vm.options
            ? _c("div", { staticClass: "row gutter-sm" }, [
                _vm.options.product_categories
                  ? _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("q-select", {
                          attrs: {
                            chips: "",
                            "autofocus-filter": "",
                            options: _vm.options.product_categories,
                            multiple: "",
                            "float-label": _vm.$t("product_categories"),
                            clearable: ""
                          },
                          model: {
                            value: _vm.product_category,
                            callback: function($$v) {
                              _vm.product_category = $$v
                            },
                            expression: "product_category"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _c("div", { staticClass: "row gutter-sm justify-end q-mt-sm" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "negative",
                    label: _vm.$t("clear_filters"),
                    icon: "fas fa-eraser"
                  },
                  on: {
                    click: function($event) {
                      return _vm.clearFilter()
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-3" },
              [
                _c("q-btn", {
                  staticClass: "full-width",
                  attrs: {
                    color: "secondary",
                    label: _vm.$t("apply_filter_plural"),
                    icon: "fas fa-filter"
                  },
                  on: {
                    click: function($event) {
                      return _vm.requestFiltered()
                    }
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }